module.exports = __webpack_public_path__ + "img/img0309.44a23f52.png";